export const Role = {




    AgentAssistant: {

        Profile:'agentAssistant',
        Pages:{
            Account:'assistantAccount',
            Home:'AssistantHome',
            Recharge:'Recharge',
            Report:'AssistantReport',
            TransactionSearch:'AssistantTransactionSearch',

        }
},
    Agent:  {
        Profile:'agent',
        Pages:{
            TransactionSearch:'AgentTransactionSearch',
            Account:'AgentAccount',
            Recharge:'Recharge',
            Home:'AgentHome',
            Report:'AgentReport'
        }
    }
}
